import VanPurchaseInfo from "./parts/van-purchase-info";

import VehicleUsage from "./parts/vehicle-usage";
import {ValidateStep2Data} from "@validators/van-insurance-form/step2-validator";
import {showValidationErrorsModal} from "@utils/modal-manager";
import SectionHeading from "@components/common/ui-elements/headings/section-heading";
import VehicleDetails from "./parts/vehicle-details";
import {WizardStepButtonsBlock} from "@components/common/form-blocks/other/wizard-step-buttons-block";

export default function IF_Step2({data, handlers, setCurrentStep}) {

    const STEP = 2;

    const onPrevBtnClick = (event) => {
        setCurrentStep(STEP - 1);
    }

    const onNextBtnClick = (event) => {

        let validationResult = ValidateStep2Data(data);

        if (validationResult.length) {

            showValidationErrorsModal({
                validationResult : validationResult
            });


        } else {
            setCurrentStep(STEP + 1);
        }


    }

    return (
        <div className='if-step-3'>

            <VehicleDetails
                data={data}
                handlers={handlers}
            />

            <SectionHeading
                text="Van usage"
            />

            {/*
                Purchase Info ...
            */}

            <VanPurchaseInfo
                data={data}
                handlers={handlers}
            />







            {/*
                Vehicle usage ...
            */}

            <VehicleUsage
                data={data}
                handlers={handlers}
            />

            {/*
                Step buttons ....
            */}
           
           <WizardStepButtonsBlock
              onPrevBtnClick={onPrevBtnClick}
              onNextBtnClick={onNextBtnClick}
           />
           
        </div>
    );

}